<template>
  <section class="section-login-body">
    <div class="row">
      <div class="col-1-of-2">
        <div class="login">
          <div class="login__form">
            <form
              class="form"
              @submit.prevent="login"
            >
              <div class="u-margin-bottom-medium">
                <h2 class="heading-secondary">
                  Email Login
                </h2>
              </div>

              <div class="form__group">
                <input
                  id="email"
                  v-model="email"
                  type="text"
                  class="form__input form__input__login"
                  placeholder="Email Address"
                  required
                  autocomplete="off"
                >
                <label
                  for="email"
                  class="form__label"
                >Email</label>
              </div>

              <div class="form__group u-margin-bottom-small">
                <input
                  id="password"
                  v-model="password"
                  type="password"
                  class="form__input form__input__login"
                  placeholder="Password"
                  required
                  autocomplete="off"
                >
                <label
                  for="password"
                  class="form__label"
                >Password</label>
              </div>

              <div
                v-if="feedback"
                class="form__group"
              >
                <label
                  for="email"
                  class="form__label"
                >{{ feedback }}</label>
              </div>

              <div
                class="form__group"
                style="margin-bottom: 4rem;"
              >
                <a
                  href="#"
                  class="btn-text"
                  style="float:left;"
                  @click.prevent="lostPassword()"
                >Password Recovery &rarr;</a>
                <button
                  class="btn btn--primary"
                  style="float:right;"
                  @click.prevent="login()"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-1-of-2">
        <div class="login">
          <div class="login__form">
            <form
              action="#"
              class="form"
            >
              <div class="u-margin-bottom-medium">
                <h2 class="heading-secondary">
                  Social Login
                </h2>
              </div>

              <div class="form__group">
                <a
                  href="#"
                  class="btn btn--facebook"
                  @click.prevent="socialFacebookLogin"
                >
                  <i class="fa fa-facebook fa-3x" />
                </a>
                <a
                  href="#"
                  class="btn btn--google"
                  @click.prevent="socialGoogleLogin"
                >
                  <i class="fa fa-google fa-3x" />
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {auth} from 'firebase/app'
import db from '@/firebase/init'
export default {
  name: 'Login',
  data () {
    return {
      email: null,
      password: null,
      feedback: null,
      additionalUserInfo: null
    }
  },
  methods: {
    lostPassword: function () {
      console.log(this.email)
      this.feedback = null
      if (!this.email) {
        this.feedback = 'Please input an email to start the password recovery'
      } else {
        const auth = firebase.auth()
        const emailAddress = this.email

        auth.sendPasswordResetEmail(emailAddress).then(() => {
          this.feedback = 'An password recovery email has been sent to ' + this.email
        }).catch((error) => {
          if (error.code === 'auth/user-not-found') {
            this.feedback = 'No user found with that email address.'
          }
        })
      }
    },
    login: function () {
      if (this.email && this.password) {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(cred => {
            if (cred) {
              if (!cred.user.emailVerified) {
                // Unverified user, lets push to Holding Page
                this.$router.push({ name: 'UserNotVerified' })
              } else {
                // verified user, lets get the user information
                firebase
                  .auth()
                  .currentUser.getIdTokenResult()
                  .then((tokenResult) => {
                    this.$store.dispatch('setAdditionalUserInfo', tokenResult.claims)
                  })

                // verified user, lets get the userprofile information
                db.collection('userDetails').where('user_id', '==', cred.user.uid).get()
                  .then(snapshot => {
                    if (snapshot.empty) {
                      console.log('No matching documents.')
                      return
                    }

                    snapshot.forEach(doc => {
                      this.$store.dispatch('setUserProfile', doc.data())
                    })
                  })
                  .catch(err => {
                    console.log('Error getting documents', err)
                  })
                // set the user in the vuex store
                this.$store.dispatch('setUser', cred.user)
                this.$router.push({ name: 'Home' })
              }
            }
          })
          .catch(err => {
            this.feedback = err.message
          })
        this.feedback = null
      } else {
        this.feedback = 'Please fill in both fields'
      }
    },
    socialGoogleLogin () {
      const provider = new auth.GoogleAuthProvider()
      this.socialLogin(provider)
    },
    socialFacebookLogin () {
      const provider = new auth.FacebookAuthProvider()
      this.socialLogin(provider)
    },
    socialTwitterLogin () {
      const provider = new auth.TwitterAuthProvider()
      this.socialLogin(provider)
    },
    socialLogin (provider) {
      auth().signInWithPopup(provider)
        .then(cred => {
          if (cred) {
            // Send the user credentials to vuex
              auth()
              .currentUser.getIdTokenResult()
              .then((tokenResult) => {
                console.log(tokenResult)
                this.$store.dispatch('setAdditionalUserInfo', tokenResult.claims)
              })

            // lets get the userprofile information
            db.collection('userDetails').where('user_id', '==', cred.user.uid).get()
              .then(snapshot => {
                if (snapshot.empty) {
                  console.log('No matching documents.')
                  return
                }

                snapshot.forEach(doc => {
                  this.$store.dispatch('setUserProfile', doc.data())
                })
              })
              .catch(err => {
                console.log('Error getting documents', err)
              })

            // set the user in the vuex store
            this.$store.dispatch('setUser', cred.user)
            this.$router.push({ name: 'Home' })
          }
        })
        .catch(err => {
          this.feedback = err.message
        })
    }
  }
}
</script>
